export default "__VITE_ASSET__DHCk3zKB__"